import React, { Component } from "react";
import axios from 'axios';
import Referral from "../src/Profile/Referral";
import Feedback from "../src/Profile/Feedback";
import { Link, Switch, Route, withRouter } from "react-router-dom";
import {
  CheckCircleIcon,
  BanIcon,
  DatabaseIcon,
  PencilIcon,
  MenuAlt1Icon,
  LightBulbIcon,
  SparklesIcon,
  UserIcon,
  CurrencyDollarIcon,
  UserCircleIcon,
} from "@heroicons/react/solid";

import Logo from "./Logo";
import config from "./config";
import MainBody from "../src/Components/Body";
import { observable, makeObservable, } from 'mobx'

import { observer, inject } from "mobx-react";

const data = [
  {
    title: "7 Free Day Trial",
    price: "FREE",
    planValue: config.stripe.free,
    duration: "100% risk free. Cancel anytime",
    description:
      "$20 USD per month if you choose to continue",
    desc: [
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1.5 1.5H22.5V4.5H1.5V1.5Z" fill="white" />
            <path d="M22.5 7.5H1.5V10.5H22.5V7.5Z" fill="white" />
            <path d="M1.5 13.5H16.5V16.5H1.5V13.5Z" fill="white" />
            <path d="M1.5 19.5H22.5V22.5H1.5V19.5Z" fill="white" />
          </svg>
        ),
        text: `<span class="font-bold">${config.stripeFreeWords}</span> Words per week`,
      },
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM10.5478 17.4581L5.29284 12.2032L7.28137 10.2147L10.6398 13.5731L17.382 7.44413L19.2743 9.52467L10.5478 17.4581Z"
              fill="white"
            />
          </svg>
        ),
        text: `<span class="font-bold">4</span> hours saved`,
      },
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_394_276)">
              <path
                d="M12 0C5.37204 0 0 5.37256 0 12C0 18.6274 5.37204 24 12 24C18.628 24 24 18.6269 24 12C24 5.37308 18.6274 0 12 0ZM12.7264 17.3454V18.7345C12.7264 18.9512 12.5577 19.1089 12.3405 19.1089H11.4146C11.1974 19.1089 11.0224 18.9512 11.0224 18.7345V17.4676C10.1702 17.429 9.31059 17.2472 8.65991 16.9997C8.30741 16.866 8.11106 16.4884 8.20454 16.1229L8.35546 15.5349C8.4082 15.3286 8.54606 15.1563 8.73458 15.0597C8.9231 14.9615 9.14452 14.9516 9.34244 15.0273C9.96231 15.267 10.6945 15.4414 11.4762 15.4414C12.4716 15.4414 13.1531 15.0571 13.1531 14.3583C13.1531 13.6946 12.5943 13.2753 11.3013 12.8382C9.43227 12.2094 8.15231 11.3363 8.15231 9.64167C8.15231 8.10479 9.24009 6.89952 11.0997 6.5324V5.2655C11.0997 5.04878 11.2851 4.85452 11.5023 4.85452H12.4282C12.6455 4.85452 12.8047 5.04878 12.8047 5.2655V6.40968C13.6178 6.44467 14.2048 6.5653 14.6957 6.7251C15.067 6.84625 15.2863 7.2353 15.1887 7.61443L15.056 8.14082C15.0043 8.34136 14.8717 8.5116 14.6899 8.60977C14.5082 8.70795 14.2936 8.72571 14.0972 8.65834C13.6512 8.50533 13.0695 8.36642 12.3321 8.36642C11.1968 8.36642 10.8297 8.85574 10.8297 9.34505C10.8297 9.92158 11.4412 10.2882 12.9259 10.8475C15.0043 11.5812 15.8393 12.5421 15.8393 14.1134C15.8388 15.668 14.7406 16.9966 12.7264 17.3454Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_394_276">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        ),
        text: `<span class="font-bold">$200</span> saved in time</span>`,
      },
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_401_271)">
              <path
                d="M13.5 0.375L15.75 8.25L23.625 10.5L15.75 12.75L13.5 20.625L11.25 12.75L3.375 10.5L11.25 8.25L13.5 0.375Z"
                fill="white"
              />
              <path
                d="M4.5 15.375L5.25 18.75L8.625 19.5L5.25 20.25L4.5 23.625L3.75 20.25L0.375 19.5L3.75 18.75L4.5 15.375Z"
                fill="white"
              />
              <path
                d="M6 1.125L6.75 3.75L9.375 4.5L6.75 5.25L6 7.875L5.25 5.25L2.625 4.5L5.25 3.75L6 1.125Z"
                fill="white"
              />
              <path
                d="M19.875 13.875L20.625 16.5L23.25 17.25L20.625 18L19.875 20.625L19.125 18L16.5 17.25L19.125 16.5L19.875 13.875Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_401_271">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        ),
        text: `<span class="font-bold">Access to all tools </span>`,
      },
    ],
    priceColor: "#F8F802",
    btnColor: "#F8F802",
  },
  {
    title: "Starter Plan",
    price: "$20 USD",
    planValue: config.stripe.entry,
    duration: "per month",
    plan: "starter",
    description: "Harness the power of AI",
    desc: [
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1.5 1.5H22.5V4.5H1.5V1.5Z" fill="white" />
            <path d="M22.5 7.5H1.5V10.5H22.5V7.5Z" fill="white" />
            <path d="M1.5 13.5H16.5V16.5H1.5V13.5Z" fill="white" />
            <path d="M1.5 19.5H22.5V22.5H1.5V19.5Z" fill="white" />
          </svg>
        ),
        text: `<span class="font-bold">${config.stripeEntryWords}</span> Words`,
      },
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM10.5478 17.4581L5.29284 12.2032L7.28137 10.2147L10.6398 13.5731L17.382 7.44413L19.2743 9.52467L10.5478 17.4581Z"
              fill="white"
            />
          </svg>
        ),
        text: `<span class="font-bold">Unlimited</span> hours saved`,
      },
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_394_276)">
              <path
                d="M12 0C5.37204 0 0 5.37256 0 12C0 18.6274 5.37204 24 12 24C18.628 24 24 18.6269 24 12C24 5.37308 18.6274 0 12 0ZM12.7264 17.3454V18.7345C12.7264 18.9512 12.5577 19.1089 12.3405 19.1089H11.4146C11.1974 19.1089 11.0224 18.9512 11.0224 18.7345V17.4676C10.1702 17.429 9.31059 17.2472 8.65991 16.9997C8.30741 16.866 8.11106 16.4884 8.20454 16.1229L8.35546 15.5349C8.4082 15.3286 8.54606 15.1563 8.73458 15.0597C8.9231 14.9615 9.14452 14.9516 9.34244 15.0273C9.96231 15.267 10.6945 15.4414 11.4762 15.4414C12.4716 15.4414 13.1531 15.0571 13.1531 14.3583C13.1531 13.6946 12.5943 13.2753 11.3013 12.8382C9.43227 12.2094 8.15231 11.3363 8.15231 9.64167C8.15231 8.10479 9.24009 6.89952 11.0997 6.5324V5.2655C11.0997 5.04878 11.2851 4.85452 11.5023 4.85452H12.4282C12.6455 4.85452 12.8047 5.04878 12.8047 5.2655V6.40968C13.6178 6.44467 14.2048 6.5653 14.6957 6.7251C15.067 6.84625 15.2863 7.2353 15.1887 7.61443L15.056 8.14082C15.0043 8.34136 14.8717 8.5116 14.6899 8.60977C14.5082 8.70795 14.2936 8.72571 14.0972 8.65834C13.6512 8.50533 13.0695 8.36642 12.3321 8.36642C11.1968 8.36642 10.8297 8.85574 10.8297 9.34505C10.8297 9.92158 11.4412 10.2882 12.9259 10.8475C15.0043 11.5812 15.8393 12.5421 15.8393 14.1134C15.8388 15.668 14.7406 16.9966 12.7264 17.3454Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_394_276">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        ),
        text: `<span class="font-bold">Priceless</span> time savings`,
      },
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_401_271)">
              <path
                d="M13.5 0.375L15.75 8.25L23.625 10.5L15.75 12.75L13.5 20.625L11.25 12.75L3.375 10.5L11.25 8.25L13.5 0.375Z"
                fill="white"
              />
              <path
                d="M4.5 15.375L5.25 18.75L8.625 19.5L5.25 20.25L4.5 23.625L3.75 20.25L0.375 19.5L3.75 18.75L4.5 15.375Z"
                fill="white"
              />
              <path
                d="M6 1.125L6.75 3.75L9.375 4.5L6.75 5.25L6 7.875L5.25 5.25L2.625 4.5L5.25 3.75L6 1.125Z"
                fill="white"
              />
              <path
                d="M19.875 13.875L20.625 16.5L23.25 17.25L20.625 18L19.875 20.625L19.125 18L16.5 17.25L19.125 16.5L19.875 13.875Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_401_271">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        ),
        text: `<span class="font-bold">Access to all tools`,
      },
    ],
    priceColor: "#F8F802",
    btnColor: "#F8F802",
  },
  {
    title: "Premium Plan",
    price: "$100 USD",
    duration: "annually",
    planValue: config.stripe.pro,
    description:
      "Fully harness the power of AI",
    plan: "premium",
    desc: [
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1.5 1.5H22.5V4.5H1.5V1.5Z" fill="white" />
            <path d="M22.5 7.5H1.5V10.5H22.5V7.5Z" fill="white" />
            <path d="M1.5 13.5H16.5V16.5H1.5V13.5Z" fill="white" />
            <path d="M1.5 19.5H22.5V22.5H1.5V19.5Z" fill="white" />
          </svg>
        ),
        text: `<span class="font-bold">${config.stripeProWords}</span> Words`,
      },
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 0C5.40891 0 0 5.40891 0 12C0 18.5911 5.40891 24 12 24C18.5911 24 24 18.5911 24 12C24 5.40891 18.5911 0 12 0ZM10.5478 17.4581L5.29284 12.2032L7.28137 10.2147L10.6398 13.5731L17.382 7.44413L19.2743 9.52467L10.5478 17.4581Z"
              fill="white"
            />
          </svg>
        ),
        text: `<span class="font-bold">Unlimited</span> hours saved`,
      },
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_394_276)">
              <path
                d="M12 0C5.37204 0 0 5.37256 0 12C0 18.6274 5.37204 24 12 24C18.628 24 24 18.6269 24 12C24 5.37308 18.6274 0 12 0ZM12.7264 17.3454V18.7345C12.7264 18.9512 12.5577 19.1089 12.3405 19.1089H11.4146C11.1974 19.1089 11.0224 18.9512 11.0224 18.7345V17.4676C10.1702 17.429 9.31059 17.2472 8.65991 16.9997C8.30741 16.866 8.11106 16.4884 8.20454 16.1229L8.35546 15.5349C8.4082 15.3286 8.54606 15.1563 8.73458 15.0597C8.9231 14.9615 9.14452 14.9516 9.34244 15.0273C9.96231 15.267 10.6945 15.4414 11.4762 15.4414C12.4716 15.4414 13.1531 15.0571 13.1531 14.3583C13.1531 13.6946 12.5943 13.2753 11.3013 12.8382C9.43227 12.2094 8.15231 11.3363 8.15231 9.64167C8.15231 8.10479 9.24009 6.89952 11.0997 6.5324V5.2655C11.0997 5.04878 11.2851 4.85452 11.5023 4.85452H12.4282C12.6455 4.85452 12.8047 5.04878 12.8047 5.2655V6.40968C13.6178 6.44467 14.2048 6.5653 14.6957 6.7251C15.067 6.84625 15.2863 7.2353 15.1887 7.61443L15.056 8.14082C15.0043 8.34136 14.8717 8.5116 14.6899 8.60977C14.5082 8.70795 14.2936 8.72571 14.0972 8.65834C13.6512 8.50533 13.0695 8.36642 12.3321 8.36642C11.1968 8.36642 10.8297 8.85574 10.8297 9.34505C10.8297 9.92158 11.4412 10.2882 12.9259 10.8475C15.0043 11.5812 15.8393 12.5421 15.8393 14.1134C15.8388 15.668 14.7406 16.9966 12.7264 17.3454Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_394_276">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        ),
        text: `<span class="font-bold">Priceless </span> time savings`,
      },
      {
        icon: (
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_401_271)">
              <path
                d="M13.5 0.375L15.75 8.25L23.625 10.5L15.75 12.75L13.5 20.625L11.25 12.75L3.375 10.5L11.25 8.25L13.5 0.375Z"
                fill="white"
              />
              <path
                d="M4.5 15.375L5.25 18.75L8.625 19.5L5.25 20.25L4.5 23.625L3.75 20.25L0.375 19.5L3.75 18.75L4.5 15.375Z"
                fill="white"
              />
              <path
                d="M6 1.125L6.75 3.75L9.375 4.5L6.75 5.25L6 7.875L5.25 5.25L2.625 4.5L5.25 3.75L6 1.125Z"
                fill="white"
              />
              <path
                d="M19.875 13.875L20.625 16.5L23.25 17.25L20.625 18L19.875 20.625L19.125 18L16.5 17.25L19.125 16.5L19.875 13.875Z"
                fill="white"
              />
            </g>
            <defs>
              <clipPath id="clip0_401_271">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        ),
        text: `<span class="font-bold">Access to all tools </span>`,
      },
    ],
    priceColor: "#F8F802",
    btnColor: "#F8F802",
  },
];


@inject("store")
@observer
class Pricing extends Component {

  render() {
    return (
      <>
        {this.props.store.profile.status ? null : (
          <div className="border-b border-gray-300 bg-[#101010] text-white shadow-sm ">
            <div className="container flex mx-auto px-4 md:px-28 flex select-none">
              <div className="relative text-gray-400 focus-within:text-green-500 flex flex-1 "></div>
              <div
                onClick={this.props.store.handleLogout}
                className="cursor-pointer text-lg flex py-3 px-6 xl:py-4 xl:px-8 hover:bg-gray-100 hover:text-black rounded-t-md font-medium transition items-center"
              >
                <UserCircleIcon className="w-7 h-7 lg:mr-4 transition" />
                <div className="hidden lg:block"> Log Out</div>
              </div>
            </div>
          </div>
        )}

        <div className="container mx-auto px-8 py-4 lg:px-28 lg:py-12 lg:pb-64 select-none">
          {this.props.store.profile.status ? null : (
            <>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <img src='/ailogo.svg' alt="MealPalAI Logo" style={{ maxWidth: 300 }} />
              </div>

              <p className="text-lg sm:text-xl md:text-2xl text-gray-400 mb-14 mt-2 text-center">
                Pick a plan to get instant access to MealPalAI
              </p>
            </>
          )}

          <div className="flex flex-col md:flex-row">
            {/* <div className="w-full md:w-1/5">&nbsp;</div>  */}
            {/* <MainBody className="px-4 py-4 md:px-28 md:py-8 lg:py-12"> */}
            <MainBody className="bg-dark-2 text-white md:px-8 md:pl-0 pt-4  mb-px  w-full">
              <Switch>
                <Route exact path="/my-profile/referral">
                  <Referral />
                </Route>
                <Route exact path="/my-profile/feedback">
                  <Feedback />
                </Route>
                <Route>
                  {/* <Grid> */}
                  {/* <div className='text-center pricing_heading'>
                                <div className='main_heading font-medium leading-tight text-5xl p-3'>Get INSTANT Access</div>
                                <div className='sub_heading'>Pick a plan to begin using MealPalAI right now!</div>
                            </div> */}
                  <div className="grid xl:grid-cols-12 xl:gap-12 custom_gird_pricing">
                    {data.map((data, key) => (
                      <>
                        <Plans key={key} data={data} props={this.props} />
                      </>
                    ))}
                  </div>

                  {/* </Grid> */}
                </Route>
              </Switch>
            </MainBody>
          </div>
        </div>
      </>
    );
  }
}

// API Call to Stripe Checkout
const submitSubscription = async (priceId, props) => {
  try {
    const response = await axios.post(
      props.store.baseURL + "user/stripe/subscribe",
      {
        token: props.store.api.defaults.headers.common["x-access-token"],
        priceId: priceId,
      }
    );

    if (response.data && response.data.url) {
      window.location.href = response.data.url;
    } else {
      // Handle the case where the response doesn't have the expected format
    }
  } catch (error) {
    console.error(error);
  }
};

const Plans = ({ data, props, userPlan }) => {
  const handleSubscribe = (priceId) => {
    if (userPlan === data.plan && props.store.profile.cancel_at_period_end) {
      props.history.push(props.store.baseURL + "user/stripe/cancel");
    } else {
      submitSubscription(priceId, props);
    }
  };

  return (
    <>
      <div className={`col-span-4 m-3 plan-card`}>
        <div className="relative mb-12">
          <div className="bg-tools-plan flex h-full rounded-xl transition hover:shadow-md overflow-hidden  text-gray-300 cursor-pointer border border-gray-300 md:flex  relative transform hover:scale-105  hover:text-white">
            <div className="p-5 flex flex-col w-full">
              <div className="price-title fixed">{data?.title}</div>
              <div
                style={{ color: `${data.priceColor}` }}
                href="#"
                className="mb-0 plan-price my-10"
              >
                {data?.price}
              </div>

              <p className="duration">{data.duration}</p>
              <p className="font-16 xl:mr-10 lg:mr-8 md:mr-6 mb-4 plan-desc">
                {data.description}
              </p>
              <div className="divider"></div>
              {data?.desc.map((desc) => (
                <>
                  <div className="flex pb-3 pt-3">
                    {desc.icon}

                    <p
                      className="ml-3 pr-1 text-sm  text-white text-opacity-50 font-16 plan-text"
                      dangerouslySetInnerHTML={{ __html: desc.text }}
                    ></p>
                  </div>
                  <div className="divider"></div>
                </>
              ))}

                <button
                  type="button"
                  onClick={() => handleSubscribe(data.planValue)}
                  className="plan-button text-center mt-12 mb-3"
                  style={{ backgroundColor: `${data.btnColor}` }}
                >
                  GET INSTANT ACCESS
                </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};


const Grid = ({ children }) => (
  <div className="grid grid-cols-1 gap-12 mt-4 xl:grid-cols-3 ">{children}</div>
);

export default withRouter(Pricing);